<table class="table-responsive table-md">
  <thead>
    <tr>
      <th>{{ 'productCrossReference.tableHeader.part' | cxTranslate }}</th>
      <th>{{ 'productCrossReference.tableHeader.catalog' | cxTranslate }}</th>
      <th>{{ 'productCrossReference.tableHeader.description' | cxTranslate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let product of PCRList">
      <td>
        <span class="responsive-title"> {{ 'productCrossReference.tableHeader.part' | cxTranslate }}: </span>

        <div class="link-reference">
          @if (product.hasReference) {
            <a [routerLink]="['/products-compare']" [queryParams]="{ pid: product.code, useProductReferences: true }">
              {{ product.partNumber }}
            </a>
          } @else {
            <button type="button" class="btn-link" (click)="noReference()">
              {{ product.partNumber }}
            </button>
          }
        </div>
      </td>

      <td>
        <span class="responsive-title"> {{ 'productCrossReference.tableHeader.catalog' | cxTranslate }}: </span>
        {{ product.catalogNumber }}
      </td>

      <td>
        <span class="responsive-title"> {{ 'productCrossReference.tableHeader.description' | cxTranslate }}: </span>
        {{ product.description }}
      </td>
    </tr>
  </tbody>
</table>
